import { useLocation } from 'react-router-dom';

const useQueryParameters = (): URLSearchParams => {
  const { search } = useLocation();
  return new URLSearchParams(search);
};

export default useQueryParameters;
